<script>
import { ref, provide } from 'vue'
import NavBar from "@/components/NavBar";
import SideBarPrintingCutting from "@/components/SideBarPrintingCutting";
import FooterBar from "@/components/FooterBar";

export default {
  components: {
    NavBar,
    SideBarPrintingCutting,
    FooterBar
  }
}
</script>

<script setup>
const sidebarVisible = ref(true)
provide('sidebarVisible', sidebarVisible)
</script>

<style scoped src="@/assets/css/inbox.css">
</style>

<template>
  <div >
    <nav-bar />

    <section class="main-content columns is-fullheight" >
			
        <div class="column is-2 sidebar-container" v-if="sidebarVisible"  >
          <SideBarPrintingCutting />
        </div>

    
        <div class=" column is-10" :class="{'is-12':sidebarVisible==false}">
          <div class="section">
            <router-view/>
          
          
          </div>
        </div>
      
		</section>

    

    <footer-bar />

  </div>

</template>



